import { Injectable } from '@angular/core';
import { QuotationCommercialItem } from 'projects/dop-ordering/src/lib/models/quotable-items/quotation-commercial-item.model';
import { CommercialItemValidationResponse } from '../../models/commercial-item-validation-response.model';
import { MonographSalesCatalogue } from '../../models/monograph/monograph-sales-catalogue.model';
import { CustomerPackagePlanningLineRule } from './customer-package-planningline.rule';
import { FreePackagePlanningLineRule } from './freepackage-planningline.rule';
import { FreeTestPlanningLineRule } from './freetest-planningline.rule';
import { MonoGraphPackagePlanningLineRule } from './monograph-package-planningline.rule';
import { MonographSCPlanningLineRule } from './monograph-salescatalogue-planningline.rule';
import { MonoGraphTestPlanningLineRule } from './monograph-test-planningline.rule';
import { SubgroupPlanningLineRule } from './subgroup-planningline.rule';

@Injectable({
    providedIn: 'root'
})
export class QuotedItemApplicabilityRule {

    freeTestPlanningLineRule: FreeTestPlanningLineRule;
    freePackagePlanningLineRule: FreePackagePlanningLineRule;
    subGroupPlanningLineRule: SubgroupPlanningLineRule;
    customerPackagePlanningLineRule: CustomerPackagePlanningLineRule;
    quotationCommercialItems: QuotationCommercialItem;
    monoGraphSalesCatalogItems: MonographSalesCatalogue;
    monographSCPlanningLineRule: MonographSCPlanningLineRule;
    monoGraphTestPlanningLineRule: MonoGraphTestPlanningLineRule;
    monographPackagePlanningLineRule: MonoGraphPackagePlanningLineRule;

    constructor(
        private quotationCommercialItem: QuotationCommercialItem,
        private monographSC: MonographSalesCatalogue) {
        this.quotationCommercialItems = quotationCommercialItem;
        this.monoGraphSalesCatalogItems = this.monographSC;
        this.freeTestPlanningLineRule = new FreeTestPlanningLineRule(this.quotationCommercialItem);
        this.freePackagePlanningLineRule = new FreePackagePlanningLineRule(this.quotationCommercialItem);
        this.subGroupPlanningLineRule = new SubgroupPlanningLineRule(this.quotationCommercialItem);
        this.customerPackagePlanningLineRule = new CustomerPackagePlanningLineRule(this.quotationCommercialItem);
        this.monographSCPlanningLineRule = new MonographSCPlanningLineRule(this.monoGraphSalesCatalogItems);
        this.monoGraphTestPlanningLineRule = new MonoGraphTestPlanningLineRule(this.monoGraphSalesCatalogItems);
        this.monographPackagePlanningLineRule = new MonoGraphPackagePlanningLineRule(this.monoGraphSalesCatalogItems);
    }

    isMonoGraphSCApplicable(salesCatalogCode: string): CommercialItemValidationResponse {
        return this.monographSCPlanningLineRule.validateMonoGraphSC(salesCatalogCode);
    }


    isFreeTestApplicable(testCode: string, ciCode: string): CommercialItemValidationResponse {
        return this.freeTestPlanningLineRule.validateTest(testCode, ciCode);
    }

    isFreePackageApplicable(packageCode: string): CommercialItemValidationResponse {
        return this.freePackagePlanningLineRule.validatePackage(packageCode);
    }

    isMonographTestApplicable(testCode: string, monographCode: string, compendiumCode: string): CommercialItemValidationResponse {
        return this.monoGraphTestPlanningLineRule.validateMonoGraphTest(testCode, monographCode, compendiumCode);
    }

    isMonographPackageApplicable(packageCode: string, monographCode: string, compendiumCode: string): CommercialItemValidationResponse {
        return this.monographPackagePlanningLineRule.validateMonoGraphPackage(packageCode, monographCode, compendiumCode);
    }

    isSGTestApplicable(subgroupCode: string, ciCode: string): CommercialItemValidationResponse {
        return this.subGroupPlanningLineRule.isSGTestApplicable(subgroupCode, ciCode);
    }

    isSGPackageApplicable(subgroupCode: string, ciCode: string): CommercialItemValidationResponse {
        return this.subGroupPlanningLineRule.isSGPackageApplicable(subgroupCode, ciCode);
    }

    isSubgroupApplicable(subgroupCode: string): CommercialItemValidationResponse {
        return this.subGroupPlanningLineRule.isSubgroupApplicable(subgroupCode);
    }

    isCPApplicable(cpCode: string): CommercialItemValidationResponse {
        return this.customerPackagePlanningLineRule.isCPApplicable(cpCode);
    }
}
